@if (!routineTemplate()) {
	<entity-deadline
		[selectedDeadline]="deadline()"
		(deadlineChanged)="deadlineChanged.emit($event)"
	/>

	<mat-radio-group id="work-order-type" (change)="changedWOType($event.value)">
		<mat-radio-button [checked]="!selectedSchedule()" value="work_order">{{
			'work_order' | translate
		}}</mat-radio-button>
		<mat-radio-button [checked]="selectedSchedule()" value="routine">{{
			'routine' | translate
		}}</mat-radio-button>
	</mat-radio-group>
}
@if (selectedSchedule()) {
	<div class="schedule-settings">
		<div class="interval">
			<form-field-label [bold]="false" [labelTranslateKey]="'repeat_every' | translate" />
			<mat-form-field>
				<mat-icon
					matPrefix
					class="cursor-pointer"
					svgIcon="minus"
					(click)="decreaseInterval()"
				/>

				<input class="interval-input" matInput type="number" [formControl]="interval" />
				<mat-icon
					matSuffix
					class="cursor-pointer"
					svgIcon="add"
					(click)="increaseInterval()"
				/>
			</mat-form-field>
		</div>
		<div class="period">
			<form-field-label [bold]="false" [labelTranslateKey]="'period' | translate" />

			<mat-form-field>
				<mat-select [formControl]="period">
					@for (period of periods; track period.value) {
						<mat-option [value]="period.value">{{ period.name | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
		<div class="selected-days">
			@if (period.value === 'DAY') {
				<div class="excludeWeekends">
					<form-field-label
						[bold]="false"
						[labelTranslateKey]="'exclude_weekends' | translate"
					/>
					<mat-form-field>
						<mat-select [formControl]="excludeWeekends">
							<mat-option [value]="true">{{ 'yes' | translate }}</mat-option>
							<mat-option [value]="false">{{ 'no' | translate }}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			} @else if (period.value === 'WEEK') {
				<form-field-label [bold]="false" [labelTranslateKey]="'pick_day' | translate" />
				<mat-form-field>
					<mat-select [formControl]="selectedDays">
						@for (day of selectedDaysValues; track day) {
							<mat-option [value]="day">{{ day | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			} @else if (period.value === 'MONTH') {
				<form-field-label
					[bold]="false"
					[labelTranslateKey]="'pick_day_month' | translate"
				/>
				<mat-form-field>
					<mat-select [formControl]="monthSetup">
						@for (day of monthSetupValues; track day) {
							<mat-option [value]="day.value">{{ day.name | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			}
		</div>
	</div>
}
